import { Type } from 'typebox';
import { Attachment } from '../reference/attachment.js';
import { LibraryLanguage } from './library-language.js';
export const StoryAge = Type.Object({
    name: Type.String()
});
export const StoryContributor = Type.Object({
    name: Type.String(),
    role: Type.Optional(Type.String())
});
export const StoryIsbn = Type.Object({
    ebook: Type.Optional(Type.String()),
    hardcover: Type.Optional(Type.String()),
    paperback: Type.Optional(Type.String())
});
export const StoryReadingLevel = Type.Object({
    azLevel: Type.Optional(Type.String()),
    azLevelInt: Type.Optional(Type.Number()),
    ccssGrade: Type.Optional(Type.String()),
    lexileCode: Type.Optional(Type.String()),
    lexileMeasure: Type.Optional(Type.Number()),
    measuredAt: Type.Optional(Type.String())
});
export const StorySource = Type.Object({
    title: Type.Optional(Type.String()),
    isCollection: Type.Optional(Type.Boolean())
});
export const StoryTiming = Type.Object({
    startTime: Type.Optional(Type.Number()),
    endTime: Type.Optional(Type.Number()),
    word: Type.String()
});
export const StoryPage = Type.Object({
    id: Type.String({ minLength: 1 }),
    ordinal: Type.Integer(),
    text: Type.Optional(Type.String()),
    backgroundImage: Type.Optional(Attachment),
    voiceOver: Type.Optional(Attachment),
    timings: Type.Optional(Type.Array(StoryTiming)),
    pinspot: Type.Optional(Type.String())
});
export const Story = Type.Object({
    id: Type.String({ minLength: 1 }),
    cmsId: Type.String({ minLength: 1 }),
    language: LibraryLanguage,
    title: Type.Optional(Type.String()),
    summary: Type.Optional(Type.String()),
    ages: Type.Array(StoryAge),
    tagList: Type.String(),
    contributors: Type.Array(StoryContributor),
    publisher: Type.Optional(Type.String()),
    copyrightYear: Type.Optional(Type.Number()),
    isbn: StoryIsbn,
    readingLevel: StoryReadingLevel,
    source: StorySource,
    wordCount: Type.Optional(Type.Number()),
    spreadLayout: Type.Boolean(),
    deleted: Type.Boolean(),
    coverArt: Type.Optional(Attachment),
    coverVoiceOver: Type.Optional(Attachment),
    titleArt: Type.Optional(Attachment)
});
export const StoryWithPages = Type.Object({
    ...Story.properties,
    pages: Type.Array(StoryPage)
});
